import React from 'react';
import styled from 'styled-components';

const Bottom = styled.div`
  padding-top: 50px;
  padding-bottom: 40px;
  border-top: 2px solid ${({ theme }) => theme.colorMain};

  @media only screen and (max-width: 810px) {
    padding-top: 40px;
    padding-bottom: 20px;
  }
`;

export default Bottom;
